class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);
    window.clearTimeout(this.closeTimer);
    this.classList.remove('is-closing');
    this.classList.add('is-opening');
    window.clearTimeout(this.openingTimer);
    this.openingTimer = window.setTimeout(() => {
      this.classList.remove('is-opening');
    }, 1500);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    if (window.bodyScrollLock) window.bodyScrollLock.lock();
    else document.body.classList.add('overflow-hidden');
  }

  close() {
    if (!this.classList.contains('active')) return;
    this.classList.remove('active');
    this.classList.add('is-closing');
    removeTrapFocus(this.activeElement);
    this.closeTimer = window.setTimeout(() => {
      this.classList.remove('is-closing');
      if (window.bodyScrollLock) window.bodyScrollLock.unlock();
      else document.body.classList.remove('overflow-hidden');
    }, 500);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      console.log(
        this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        )
      );
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.inFlight = false;
    this.queued = null;
    this.dirty = false;
    this.addEventListener('change', () => {
      this.dirty = true;
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  updateQuantity(line, quantity) {
    this.dirty = false;
    if (this.inFlight) {
      this.queued = [line, quantity];
      return;
    }
    this.inFlight = true;

    const drawer = this.closest('cart-drawer');
    const item = document.getElementById(`CartDrawer-Item-${line}`);
    let minDelay = Promise.resolve();
    if (item) {
      if (Number(quantity) === 0) {
        item.style.height = `${item.offsetHeight}px`;
        void item.offsetHeight;
        item.classList.add('is-removing');
        minDelay = new Promise((resolve) => window.setTimeout(resolve, 380));
      } else {
        item.classList.add('is-updating');
      }
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: 'cart-drawer,shared_header',
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then(async (state) => {
        let errorMessage = '';
        let sections = state.sections;
        if (state.errors || state.message) {
          errorMessage =
            state.description ||
            (typeof state.errors === 'string' ? state.errors : '') ||
            window.cartStrings.error;
          sections = null;
        }

        const sendQueued = () => {
          if (!this.queued) return false;
          const next = this.queued;
          this.queued = null;
          this.inFlight = false;
          this.updateQuantity(...next);
          return true;
        };

        const deadline = Date.now() + 600;
        while (this.dirty && Date.now() < deadline) {
          await new Promise((resolve) => window.setTimeout(resolve, 40));
        }
        if (sendQueued()) return;

        if (!sections) {
          sections = await fetch(
            `${routes.cart_url}?sections=cart-drawer,shared_header`
          ).then((response) => response.json());
        }

        await minDelay;
        if (sendQueued()) return;

        const parser = new DOMParser();
        const inner = parser
          .parseFromString(sections['cart-drawer'], 'text/html')
          .querySelector('.drawer__inner');
        const currentInner = drawer.querySelector('.drawer__inner');
        if (inner && currentInner) currentInner.innerHTML = inner.innerHTML;

        const bubble = parser
          .parseFromString(sections['shared_header'], 'text/html')
          .querySelector('#cart-icon-bubble');
        const currentBubble = document.querySelector('#cart-icon-bubble');
        if (bubble && currentBubble) currentBubble.innerHTML = bubble.innerHTML;

        drawer.classList.toggle('is-empty', !drawer.querySelector('.cart-item'));

        if (errorMessage) {
          const errors = drawer.querySelector('#CartDrawer-CartErrors');
          if (errors) errors.textContent = errorMessage;
        } else {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: state,
          });
        }
        this.inFlight = false;
      })
      .catch(() => {
        this.inFlight = false;
        this.queued = null;
        drawer
          .querySelectorAll('.cart-item.is-updating')
          .forEach((entry) => entry.classList.remove('is-updating'));
        const errors = drawer.querySelector('#CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
